// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RgaList from '../components/rga-result-list';
import RgaSearchModel from '../../search/state/rga-search-model';
import RgaSearchResults from '../state/rga-search-result';
import SearchFilters from '../../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import UsefulLinksPanel from '../../search/components/useful-links-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleOnMassUpdate() {

    this.actions.openMassUpdateModal();

}
function handleOnMassUpload() {

    this.actions.openMassUploadModal();

}

class RgaSearchResult extends Component {

    constructor(props) {

        super(props);

        const isRestoringResults = props.resultsNavigation.shouldRestore && props.rgaList.length > 0;
        const currentPage = isRestoringResults ? (props.resultsNavigation.currentPage || 1) : 1;

        this.state = {
            currentPage,
            totalElements: 100000,
            totalPages: isRestoringResults && props.isEmptyRgaSearchResult ? currentPage + 1 : 1000
        };

        this.isRestoringResults = isRestoringResults;

    }

    componentDidMount() {

        if (this.isRestoringResults) {

            this.restorePreviouslyOpenedResult();
            this.props.actions.setRgaResultsNavigation({
                shouldRestore: false
            });

            return;

        }

        this.loadInitialCollections();

    }

    componentWillUnmount() {

        if (!this.props.resultsNavigation.shouldRestore) {

            this.props.actions.updateFilterBy('');
            this.props.actions.setRgaResultFlag(false);

        }

    }

    loadInitialCollections() {

        this.props.actions.getRgaCollections(this.props.rgaSearchModel, false, true, this.state.currentPage);
        this.props.actions.resetRgaResultsNavigation();
        this.setInitialTotalPages();

    }

    restorePreviouslyOpenedResult() {

        const {lastOpenedRgaNumber} = this.props.resultsNavigation;

        if (!lastOpenedRgaNumber) {

            return;

        }

        setTimeout(() => {

            const result = document.querySelector(`[data-rga-search-number="${lastOpenedRgaNumber}"]`);

            if (result) {

                result.scrollIntoView({
                    block: 'center'
                });

            }

        }, 0);

    }

    setInitialTotalPages() {

        if (this.props.isEmptyRgaSearchResult) {

            this.setState({
                totalPages: this.state.currentPage + 1
            });

        } else {

            this.setState({
                totalPages: 1000
            });

        }

    }

    render() {

        return (
            <section className='rga-list'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='rga-list-aside'>
                    <UsefulLinksPanel
                        onMassUpdate={handleOnMassUpdate.bind(this.props)}
                        onMassUpload={handleOnMassUpload.bind(this.props)}
                        security={this.props.security}
                    />
                </aside>
                <main className='rga-list-main'>
                    <RgaList
                        actions={this.props.actions}
                        currentPage={this.state.currentPage}
                        handleMore={count => {

                            this.props.actions.getRgaCollections(this.props.rgaSearchModel, false, false, count + 1);
                            this.setState({currentPage: count + 1});
                            this.props.actions.setRgaResultsNavigation({
                                currentPage: count + 1
                            });
                            if (this.props.isEmptyRgaSearchResult) {

                                this.setState({
                                    totalPages: this.state.currentPage + 1
                                });

                            }

                        }}
                        infoReqStatus={this.props.infoReqStatus}
                        parenpropsLocation={this.props.parenpropsLocation}
                        partReqStatus={this.props.partReqStatus}
                        photoReqStatus={this.props.photoReqStatus}
                        rgaList={this.props.rgaList}
                        rgaSearchModel={this.props.rgaSearchModel}
                        searchFilters={this.props.searchFilters}
                        totalElements={this.state.totalElements}
                        totalPages={this.state.totalPages}
                    />
                </main>
            </section>
        );

    }

}

RgaSearchResult.displayName = 'RgaSearchResult';
RgaSearchResult.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    infoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    isEmptyRgaSearchResult: PropTypes.bool.isRequired,
    parenpropsLocation: PropTypes.object.isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    photoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    resultsNavigation: PropTypes.object.isRequired,
    rgaList: PropTypes.arrayOf(PropTypes.instanceOf(RgaSearchResults)).isRequired,
    rgaSearchModel: PropTypes.arrayOf(PropTypes.instanceOf(RgaSearchModel)).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};
export default RgaSearchResult;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/components/index.js